import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import RouteWithNavElements from "./RouteWithNavElements";

// Redux stuff
import { connect } from "react-redux";

const AuthRoute = ({ exact, path, component, authenticated, ...rest }) => {
  if (authenticated === true) {
    return <Redirect to="/" />;
  } else {
    return (
      <RouteWithNavElements exact path={path} component={component} {...rest} />
    );

    // <Component {...rest} />;
  }
};

const mapStateToProps = (state) => ({
  authenticated: state.user.authenticated,
});

AuthRoute.propTypes = {
  user: PropTypes.object,
};

export default connect(mapStateToProps)(AuthRoute);
